/**
 * Created by Ning Jiang on 2022-01-05.
 */

export class SpineHelper {

    public static destroySpine(spine:PIXI.spine.Spine):void {
        spine.state.clearTrack(0);
        spine.skeleton.setToSetupPose();
        spine.state.setEmptyAnimation(0, 0);
        if(spine.parent) {
            spine.parent.removeChild(spine);
        }
        spine.destroy();
    }
}